import ScrollReveal from "scrollreveal";

export function idxFunc() {
  //スクロールアニメーション
  ScrollReveal().reveal('.anm', {
    duration: 1500,
    viewFactor: 0.2,
    distance: '20px',
    origin: 'bottom'
  });
}
